(() => {
  const initialized = new WeakSet();

  function initSequence(root) {
    if (!root || initialized.has(root)) return;
    initialized.add(root);

    const slides = Array.from(root.querySelectorAll('.sp-hero__owned-slide'));
    if (slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let index = 0;
    let timer = null;
    const clear = () => {
      if (timer) window.clearTimeout(timer);
      timer = null;
    };

    const show = (nextIndex) => {
      clear();
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === nextIndex);
        const video = slide.querySelector('video');
        if (video && slideIndex !== nextIndex) {
          video.pause();
          video.currentTime = 0;
          video.onended = null;
        }
      });
      index = nextIndex;
      const active = slides[index];
      const video = active.querySelector('video');
      const advance = () => show((index + 1) % slides.length);

      if (video) {
        video.currentTime = 0;
        video.onended = advance;
        const result = video.play();
        if (result && typeof result.catch === 'function') {
          result.catch(() => { timer = window.setTimeout(advance, 5000); });
        }
      } else {
        const duration = Number(active.dataset.duration || 2200);
        timer = window.setTimeout(advance, duration);
      }
    };

    document.addEventListener('visibilitychange', () => {
      const video = slides[index]?.querySelector('video');
      if (document.hidden) {
        clear();
        video?.pause();
      } else {
        show(index);
      }
    });

    show(0);
  }

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-sp-hero-sequence]').forEach(initSequence);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
